import React from 'react';

import {Provider} from 'jotai';
import Product from './cart-product';

import useCart from 'modules/cart/util/use-cart';
import Column from 'shared/components/column';
import {SemiBoldText} from 'shared/components/text';
import styled from 'styled-components';

const CartProducts: React.FC = () => {
  const {cart, removeProduct, incrementQuantity, decrementQuantity} = useCart();

  return (
    <Container>
      <SemiBoldText>Produtos</SemiBoldText>
      {cart?.products.length > 0 && (
        <Column gap={10}>
          {cart?.products.map((product, index) => (
            <Provider key={index}>
              <Product
                {...{
                  ...product,
                  index,
                  removeProduct: () => removeProduct(index),
                  incrementQuantity: () => incrementQuantity(index),
                  decrementQuantity: () => decrementQuantity(index),
                  products: cart?.products,
                }}
              />
            </Provider>
          ))}
        </Column>
      )}
      {!cart?.products.length && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <SemiBoldText size="small" color="primary">
            Nenhum produto informado
          </SemiBoldText>
        </div>
      )}
    </Container>
  );
};

export default CartProducts;

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: '15px 0',
});
